import React, {Component} from 'react';
import IconBoxes from '../../components/iconBoxes.js';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import Panel from '../../components/panel.js';

import IncomeDiscount from '../../charts/incomeDiscount' ;
import RestricteDAccounts from '../../charts/restrictedAccounts';
import RestrictedAmounts from '../../charts/restrictedAmounts'
import MonthlyRecovery from '../../charts/monthlyRecovery';
import ChannelEffectiveness from '../../charts/channelEffectiveness';
import AgreementAcommplishment from '../../charts/agreementAcommplishment';
import {Redirect} from 'react-router';
import {ROL} from '../../utils/constants';

class PlaceManagement extends Component {

  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData}
  }

  render() {
    var result;
    if (this.state.userData.rol === ROL.MANAGEMENT.url) {
      result = <div>
        <SidebarMenuRouters profile="/profile-management/place/" place={this.props.match.params.vp}/>
        <Header userName={this.state.userData.name} title={"Análisis de desempeño"}/>
        <div className="grid-data-dash">
          <IconBoxes bu={this.props.match.params.vp}/>
          <div className="row">
            <div className="col-sm-6">
              <Panel title="Recuperación mensual de adeudos (mdp)" righticon={false}>
                <MonthlyRecovery bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Ingresos contra descuentos" righticon={false}>
                <IncomeDiscount bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Efectividad por canal" righticon={false}>
                <ChannelEffectiveness bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Cumplimiento de convenios" righticon={false}>
                <AgreementAcommplishment bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Cuentas restringidas" righticon={false}>
                <RestricteDAccounts bu={this.props.match.params.vp}/>
              </Panel>
            </div>
            <div className="col-sm-6">
              <Panel title="Montos restringidos " righticon={false}>
                <RestrictedAmounts bu={this.props.match.params.vp}/>
              </Panel>
            </div>
          </div>
        </div>
      </div>
    } else {
      result = <Redirect to={"/"}/>
    }
    return (
      <div>
        {result}
      </div>
    );
  }
}

export default PlaceManagement;



// WEBPACK FOOTER //
// ./src/scene/management/placeManagement.js